<template>
  <div class="login_container">
    <Logo />
    <div class="formlogin_container md-elevation-5">
      <h2>Login</h2>
      <div class="form_controller">
        <div class="group_name">
          <input
            type="text"
            name="username"
            class="input_name"
            placeholder="Login name"
            v-model.lazy="username"
          />
          <div>Login name</div>
        </div>
        <div class="group_password">
          <div :style="{ color: color }">Password</div>
          <div class="input_password">
            <input
              :type="input_type"
              name="password"
              placeholder="Password"
              v-model="password"
              @focus="handleFocus"
              @blur="handleBlur"
              v-on:keyup.enter="handleGetOTP"
            />
            <div @click="handleShowPass" class="show_icon" v-if="icon_enable">
              <md-icon>{{ icon_name }}</md-icon>
            </div>
          </div>
        </div>
        <md-button class="md-raised md-primary btn_login" @click="handleGetOTP"
          >Login</md-button
        >
        <md-button class="md-primary" @click="handleForgot">Forgot password?</md-button>
      </div>
    </div>
    <Footer></Footer>
    <md-dialog :md-active.sync="verify_active" :md-click-outside-to-close="false" class="custom_dialog_container dialog_verify_login">
          <md-dialog-title >
            <!-- <label class='lb_close' @click="verify_active=false"><md-icon class="icon_close ">clear</md-icon></label> -->
            <label class='lb-title'>Verify OTP</label>
          </md-dialog-title>
          <md-dialog-content>
            <div>
                <div class="custom_input" style="margin-top:0px">
                    <input type="password"   placeholder="*******" minlength="6" maxlength="6" v-model="otp_code">
                    <label>Please check your mail to get OTP Code</label>
                </div>         
            </div>
            <div class="header_alert">
              <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.617 3.47166L17.4045 15.3636C17.4671 15.4731 17.5 15.5974 17.5 15.7239C17.5 15.8504 17.4671 15.9747 17.4045 16.0843C17.342 16.1939 17.2521 16.2848 17.1438 16.3481C17.0354 16.4114 16.9126 16.4447 16.7875 16.4447H3.2125C3.08743 16.4447 2.96456 16.4114 2.85625 16.3481C2.74794 16.2848 2.65799 16.1939 2.59546 16.0843C2.53292 15.9747 2.5 15.8504 2.5 15.7239C2.5 15.5974 2.53292 15.4731 2.59546 15.3636L9.38295 3.47166C9.44549 3.3621 9.53544 3.27113 9.64375 3.20788C9.75207 3.14463 9.87493 3.11133 10 3.11133C10.1251 3.11133 10.2479 3.14463 10.3562 3.20788C10.4646 3.27113 10.5545 3.3621 10.617 3.47166ZM9.28748 12.841V14.2825H10.7125V12.841H9.28748ZM9.28748 7.79599V11.3996H10.7125V7.79599H9.28748Z" fill="#F27B2C"/>
              </svg>
               <span>OTP Code will expired in {{ count}} seconds!</span>
          </div>
            </md-dialog-content>
            <md-dialog-actions>
              <md-button class="md-raised md-primary " @click="handleLogin">Submit</md-button>
            </md-dialog-actions>
      </md-dialog>
      <md-dialog :md-active.sync="loading" :md-click-outside-to-close="false" class="custom_dialog_container">
        <md-dialog-title >
          <label class='lb-title'>Checking</label>
        </md-dialog-title>
        <md-dialog-content>
          <center><md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner></center>
        </md-dialog-content>
      </md-dialog>

      <md-dialog :md-active.sync="forgot_active" :md-click-outside-to-close="true" class="custom_dialog_container dialog_verify_login">
          <md-dialog-title >
            <!-- <label class='lb_close' @click="verify_active=false"><md-icon class="icon_close ">clear</md-icon></label> -->
            <label class='lb-title'>Forgot Password</label>
          </md-dialog-title>
          <md-dialog-content>
            <div>
                <div class="custom_input" style="margin-top:0px">
                    <input type="text"   placeholder="Login name"  v-model="username_forgot">
                    <label>Login name</label>
                </div>         
            </div>
            <div class="header_alert">
              <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.617 3.47166L17.4045 15.3636C17.4671 15.4731 17.5 15.5974 17.5 15.7239C17.5 15.8504 17.4671 15.9747 17.4045 16.0843C17.342 16.1939 17.2521 16.2848 17.1438 16.3481C17.0354 16.4114 16.9126 16.4447 16.7875 16.4447H3.2125C3.08743 16.4447 2.96456 16.4114 2.85625 16.3481C2.74794 16.2848 2.65799 16.1939 2.59546 16.0843C2.53292 15.9747 2.5 15.8504 2.5 15.7239C2.5 15.5974 2.53292 15.4731 2.59546 15.3636L9.38295 3.47166C9.44549 3.3621 9.53544 3.27113 9.64375 3.20788C9.75207 3.14463 9.87493 3.11133 10 3.11133C10.1251 3.11133 10.2479 3.14463 10.3562 3.20788C10.4646 3.27113 10.5545 3.3621 10.617 3.47166ZM9.28748 12.841V14.2825H10.7125V12.841H9.28748ZM9.28748 7.79599V11.3996H10.7125V7.79599H9.28748Z" fill="#F27B2C"/>
              </svg>
               <span>Please check email to reset password in 10 minutes!</span>
          </div>
            </md-dialog-content>
            <md-dialog-actions>
              <md-button class="md-raised md-primary " @click="handleForgotSubmit">Submit</md-button>
            </md-dialog-actions>
      </md-dialog>
  </div>
</template>
<script>
import Footer from "../components/Footer";
import Logo from "@/components/Logo";
import request from "@/utils/request.js";
import tokenUtils from "@/utils/token.js";
export default {
  name: "Login",
  components: {
    Footer,
    Logo,
  },
  data() {
    return {
      icon_name: "visibility_off",
      username: "",
      password: "",
      color: "#6D6E71",
      input_type: "password",
      icon_enable: false,
      verify_active:false,
      forgot_active:false,
      username_forgot:'',
      timer:null,
      count:0,
      user_id:"",
      otp_code:"",
      loading:false,
      autoClose:false
    };
  },
  // created(){
  //   this.count=10
  //   this.timer = setInterval(() => {
  //     console.log('count down!')
  //     this.count=this.count-1
  //     if(this.count==0){
  //       this.verify_active = false
  //     }
  //   }, 1000);
  // },
  methods: {
    handleFocus() {
      this.color = "#0080F6";
    },
    handleBlur() {
      this.color = "#6D6E71";
    },
    handleShowPass() {
      if (this.icon_name === "visibility_off") {
        this.input_type = "text";
        this.icon_name = "visibility";
      } else {
        this.input_type = "password";
        this.icon_name = "visibility_off";
      }
    },
    handleForgot(){
      this.forgot_active = true
    },
    handleForgotSubmit(){
      if(!this.username_forgot){
        return alert('Please fill login name!')
      }
      this.forgot_active = false
      this.loading = true
      request("post", "/auth/forgot-pass", {
        username: this.username_forgot,
      })
      .then(res=>{
        this.loading = false
        if(res.code!=='000'){
          return alert(res.message)
        }
      })
      .catch(err=>{
        this.loading = false
        alert(err)
      })
    },
    handleGetOTP(){
      this.loading=true
      request("post", "/auth/get_otp", {
        username: this.username,
        password: this.password,
      })
      .then(res=>{
        this.loading = false
        if(res.code==='999'){
          let { token,user } = res;
          tokenUtils.save(token);

          let payload = tokenUtils.load();
          this.$store.commit("changeUsername", payload.username);
          this.$store.commit("changeRole", payload.role);
          this.$store.commit("changeInfo", user);

          this.$router.push("/");
          return
        }
        else if(res.code!=='000'){
          return alert(res.message)
        }
        this.user_id = res.user_id
        this.count = res.count
        this.verify_active = true
        this.timer = setInterval(()=>{
          this.count = this.count -1
        },1000)
      })
      .catch(err=>{
        this.loading = false
        alert(err)
      })
    },
    handleLogin() {
      if(!this.user_id){
        return alert('OTP Code is invalid!')
      }
      if(this.otp_code.length!==6 || isNaN(this.otp_code)){
        return alert('OTP Code is invalid!')
      }
      request("post", "/auth/login", {
        user_id: this.user_id,
        otp_code: this.otp_code,
      })
        .then((data) => {
          if(data.code!=='000'){
            this.otp_code = ""
            return alert(data.message)
          }
          let { token,user } = data;
          tokenUtils.save(token);

          let payload = tokenUtils.load();
          this.$store.commit("changeUsername", payload.username);
          this.$store.commit("changeRole", payload.role);
          this.$store.commit("changeInfo", user);

          this.$router.push("/");
        })
        .catch((err) => {
          
          alert(err)
          
          
        });
    },
  },
  watch: {
    password: function () {
      if (this.password.length > 0) {
        this.icon_enable = true;
      } else {
        this.icon_enable = false;
      }
    },
    count:function(){
      if(this.count<0){
        clearInterval(this.timer)
        this.verify_active = false
        alert('OTP code is expired!')
        console.log("clear interval!")
        this.otp_code = ""
        this.user_id = ""
      }
    }
  },
};
</script>
<style lang="scss">
.login_container {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  --textColor: #6d6e71;
  position: relative;
  z-index: 1;

}
.dialog_verify_login{
    .md-dialog-actions{
      .md-button{
        width: 100%;
        margin-left:0px !important;
      }
    }
  }
.formlogin_container {
  width: 500px;
  height: 440px;
  background-color: white;
  h2 {
    margin-top: 38px;
  }
  .form_controller {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 47px;

    .group_name {
      margin-bottom: 17px;
      display: flex;
      flex-direction: column-reverse;
      div {
        text-align: left;
        margin-bottom: 5px;
        color: var(--textColor);
      }
      input {
        width: 361px;
        height: 48px;
        background-color: #ececec;
        border-width: 0px;
        border-radius: 3px;
        padding: 8px;
      }
      input:focus {
        outline: none !important;
        border: 1px solid #0080f6 !important ;
      }
      input:focus + div {
        color: #0080f6;
      }
    }
    .group_password {
      margin-bottom: 16px;
      display: flex;
      flex-direction: column;
      div {
        text-align: left;
        margin-bottom: 5px;
        color: var(--textColor);
      }
      .input_password {
        width: 361px;
        height: 48px;
        position: relative;
        display: flex;
        align-items: center;
        input {
          width: 100%;
          height: 100%;
          background-color: #ececec;
          border-width: 0px;
          border-radius: 3px;
          padding: 8px;
          z-index: 0;
        }
        input:focus {
          outline: none !important;
          border: 1px solid #0080f6 !important;
        }

        .show_icon {
          position: absolute;
          right: 14px;
          margin: auto;
          z-index: 100;
        }
      }
    }
    .btn_login {
      width: 361px;
      height: 48px;
      font-weight: bold;
      text-transform: none;
      font-size: 1rem;
    }
  }
}
</style>
